import React, { useState } from "react";
import { Header, InformationMsg, List } from "./component";
import "./MonthlyTimeSheet.css";

const MonthlyTimeSheet = () => {
  const [extraFiltersState, setExtraFiltersState] = useState({
    values: {},
  });
  const [currentMonth, setCurrentMonth] = useState(null);

  return (
    <div className="wrapper-div">
      <Header 
        extraFiltersState={extraFiltersState}
        setExtraFiltersState={setExtraFiltersState}
        setCurrentMonth={setCurrentMonth}
      />
        
      <List 
        extraFiltersState={extraFiltersState}
        setExtraFiltersState={setExtraFiltersState}
        currentMonth={currentMonth}
        setCurrentMonth={setCurrentMonth}
      />
    </div>
  );
};

export default MonthlyTimeSheet;
